import React from "react";
import axios from "axios";
import { ucfirst, strstr, str_replace } from './Utilities';

/*
 * Class that displays totals at the bottom of charts
 *
 */

class ReportsTotals extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            total: null,
        };
    }

    componentDidMount() {
        this.getTotal();
    }

    getTotal() {
        const endpoint = this.props.endpoint;
        const url = `react/process?endpoint=${endpoint}&includeonetime=1&turnoffdebug=1&totalMemberCountOnly=1`;
        // console.log(url);
        axios.get(url).then(response => this.formatData(response.data));
    }

    formatData(data) {
        this.props.sendToTable(data);
        this.setState({ total: data });
    }

    render() {
        const { total } = this.state;
        const { next, limit } = this.props;

        if (total === null) return null;

        // Remove any '~' or commas and convert to a number.
        let cleanedTotal = parseInt(total.toString().replace(/[~,]/g, ''), 10);
        if(isNaN(cleanedTotal)) cleanedTotal = 0;

        // Normalize the page number. If next is 0 or falsy, treat it as 1.
        const currentPage = next || 1;  
        const offset = (currentPage - 1) * limit;
        var start = (cleanedTotal !== 0) ? offset + 1 : 0;
        var end = (cleanedTotal !== 0) ? Math.min(offset + limit, cleanedTotal) : 0;

        let displayText = `Showing ${start} to ${end} of ~${cleanedTotal.toLocaleString()} members`;       
        if (cleanedTotal <= limit) {
            displayText = `Showing ${cleanedTotal.toLocaleString()} member${(cleanedTotal > 1 || cleanedTotal == 0) ? 's' : ''}`;
        }

        return <p><strong>{displayText}</strong></p>;
    }

}

export default ReportsTotals;